// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1767":"e2575e355f605537","2191":"b814ef3ab774e51c"}[chunkId] + ".css";
};